import { IOpeningTime, TEditVenueOpeningTimes } from '../../../components/VenueOpeningTimeEditModal/types';
import { TDay } from 'src/types/venue.types';
import { updateVenueOpeningTime } from '../../../api/updateVenueOpeningTime/updateVenueOpeningTime';
import { FieldNamesMarkedBoolean } from 'react-hook-form';
import filterChangedDays from '../filterChangedDays';

export const updateExistingOpeningTimes = (
  venueId: string,
  openingTimes: TEditVenueOpeningTimes,
  dirtyFields: Partial<Readonly<FieldNamesMarkedBoolean<TEditVenueOpeningTimes>>>,
): Promise<any>[] => {
  // get list of changed days
  const changedDays = filterChangedDays(dirtyFields);
  if (changedDays.length === 0) return [];
  // array of all opening times
  const changedOpeningTimes = [];
  Object.keys(openingTimes).forEach((day: TDay) => {
    openingTimes[day].forEach((time: IOpeningTime) => {
      // check opening time is not a new one and is not empty
      if (time.openingTimeId !== '' && time.start !== '' && time.end !== '') {
        // check opening time has been updated
        if (changedDays.includes(day)) {
          changedOpeningTimes.push({
            ...time,
            day,
          });
        }
      }
    });
  });
  return changedOpeningTimes.map((time) =>
    updateVenueOpeningTime(venueId, time.openingTimeId, {
      day_of_week: time.day,
      start_time: time.start,
      end_time: time.end,
    }),
  );
};
